// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Leak_wrapper__1x54K","text":"Leak_text__sw0VL","image":"Leak_image__3Bbmq","imageLeak":"Leak_imageLeak__1LJzx"};